import React, { useContext, useRef, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import walkersService from "../../../services/walkers.service";
import TmsCommonService from "../../../services/tms-common.service";
import { BaseContext } from "../../../contexts/BaseContext";
import Webcam from "react-webcam";

const PosChildrenWalkin = ({ router }) => {
  const { userDetails } = useContext(BaseContext);

  const [buttonLoading, setButtonLoading] = useState(false);
  const [ticketId, setTicketId] = useState();
  const [name, setName] = useState("");
  const [father, setFather] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState();
  const [gender, setGender] = useState();
  const [capturedImage, setCapturedImage] = useState(null);
  const webcamRef = useRef(null);

  const onChangeTicketId = (e) => {
    setTicketId(e.target.value);
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const recaptureImage = () => {
    setCapturedImage(null);
  };

  const handleSubmit = async () => {
    if (!capturedImage) {
      notification.info({
        message: "Please capture a photo",
      });
      return;
    }

    // Convert the base64 image data to a binary Blob
    const binaryData = atob(capturedImage.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: "image/jpeg" });

    let formData = new FormData();
    formData.append("file", blob);

    const url = await TmsCommonService.uploadTempFile(
      formData,
      "person",
      userDetails.user.id
    );

    if (name == "" || mobile == "" || gender == "") {
      notification.info({
        message: "Please fill all the fields",
      });
      setButtonLoading(false);
      return;
    }

    try {
      await walkersService.createChildernTagUser({
        childrenTagId: ticketId,
        name: name,
        fatherName: father,
        mobile: mobile,
        address: address,
        gender: gender,
        familyPhotoUrl: url.path,
        childPhotoUrl: url.path,
      });
      notification.success({
        message: "Successfully created",
      });
      setMobile("");
      setName("");
      setGender("");
      setTicketId("");
      setFather("");
      setAddress("");
      setCapturedImage(null);
      setButtonLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setButtonLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title>Children Walkers Tag </Typography.Title>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>
          <Col justify="center" style={{ width: "100%" }}>
            <Col
              className="mobile-responsive-width"
              style={{ textAlign: "left" }}
            >
              {" "}
              Children Walkers Tag:{" "}
            </Col>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              {" "}
              <Input
                size="large"
                autoFocus={true}
                maxLength={220}
                value={ticketId}
                onChange={onChangeTicketId}
                onKeyDown={onKeyDown}
                className="mobile-responsive-width"
                placeholder="Enter Walkers Tag"
              />
            </div>
          </Col>

          {ticketId && (
            <div
              style={{
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  width: "100%",
                }}
              >
                <label>Children Name</label>
                <Input
                  size="large"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Children Name"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  width: "100%",
                }}
              >
                <label>Father Name</label>
                <Input
                  size="large"
                  value={father}
                  onChange={(e) => setFather(e.target.value)}
                  placeholder="Enter Father Name"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  width: "100%",
                }}
              >
                <label>Address</label>
                <Input
                  size="large"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Enter Address"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  width: "100%",
                }}
              >
                <label>Mobile</label>
                <InputNumber
                  size="large"
                  type="number"
                  style={{ width: "100%" }}
                  value={mobile}
                  onChange={(value) => {
                    if (value.length > 10) {
                      return;
                    }
                    setMobile(value);
                  }}
                  placeholder="Enter Mobile Number"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  width: "100%",
                }}
              >
                <label>Gender</label>
                <Select
                  size="large"
                  value={gender}
                  onChange={(e) => {
                    setGender(e);
                  }}
                  style={{ width: "100%" }}
                  placeholder="Select Gender"
                >
                  <Select.Option value="male">Male</Select.Option>
                  <Select.Option value="female">Female</Select.Option>
                </Select>
              </div>

              <br />
              <Button
                size="large"
                type="primary"
                onClick={(e) => {
                  e.preventDefault();
                  !buttonLoading && handleSubmit();
                }}
                loading={buttonLoading}
              >
                Submit
              </Button>
            </div>
          )}
        </Col>
        <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "400px",
                height: "330px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {capturedImage ? (
                <img
                  src={capturedImage}
                  alt="Captured"
                  width={400}
                  height={330}
                />
              ) : (
                <Webcam
                  className="poscapture"
                  width={400}
                  height={330}
                  ref={webcamRef}
                />
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "30px",
              justifyContent: "center",
            }}
          >
            {!capturedImage ? (
              <Button type="primary" onClick={captureImage}>
                Capture
              </Button>
            ) : (
              <>
                <Button type="primary" onClick={recaptureImage}>
                  Recapture
                </Button>
                <Button type="default" onClick={() => setCapturedImage(null)}>
                  Cancel
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default withRouter(PosChildrenWalkin);
